<app-widget-card-wrapper [title]="chartTitle">
  <h5 class="card-title-medium" style="color: #000000">Displays % of maximum consented volume</h5>
  <div class="watertake-chart-container">
    <div echarts [options]="watertakeOption"></div>
    <div echarts [options]="watertakeAvgOption"></div>
  </div>
</app-widget-card-wrapper>
